import { cn } from './ui';

interface SchoolNameProps {
  name: string;
  className?: string;
}

/**
 * Название школы. Набирается как на баннере: широкий геометрический гротеск,
 * верхний регистр, расширенный трекинг.
 *
 * Отдельный компонент, потому что название встречается в шапке кабинета, на
 * лендинге, на странице записи и на экране входа — набранное каждый раз по-
 * своему, оно перестаёт читаться как одно и то же имя. Кегль задаётся снаружи:
 * в шапке телефона и на первом экране он разный.
 */
export function SchoolName({ name, className }: SchoolNameProps): React.JSX.Element {
  return (
    <span className={cn('font-display font-bold uppercase tracking-[0.08em]', className)}>
      {name}
    </span>
  );
}
